import { AbstractControl } from '@angular/forms';

// A ladder charges in one currency and measures in one unit. The rate path takes the measure from the
// first rule alone, so a row left disagreeing with it would price by a unit the merchant cannot see.
export const LADDER_WIDE_KEYS = ['type', 'stepUnit'];

export function setLadderRuleValue(rules: AbstractControl[], index: number, key: string, value: unknown): void {
  if (LADDER_WIDE_KEYS.includes(key)) {
    rules.forEach((rule) => rule.get(key)?.setValue(value));
    return;
  }
  rules[index]?.get(key)?.setValue(value);
}
